import { AppState } from 'Store'
import { OTHER_GROUP_NAME, CapabilitiesByProductGroupsType } from 'Pages/dashboard'
import { createSelector } from 'reselect'

const getDashboardDataSelector = (state: AppState) => state.dashboard.data
const getDashboardDataPartner = (state: AppState) => state.dashboard.data?.partner
const getDashboardLoadingSelector = (state: AppState) => state.dashboard.isLoading
const getDashboardDateInfoSelector = (state: AppState) => state.dashboard.dateInfo
const getIsOpenHeaderSelector = (state: AppState) => state.dashboard.openHeader
const getDashboardPartnerSelector = (state: AppState) => state.dashboard.selectedPartner
const getShowPartnerSelectSelector = (state: AppState) => state.dashboard.showPartnerSelect
const getDashboardWidgetCapabilitiesFullSelector = (state: AppState) =>
	state.dashboard.capabilitiesWidget.values

const getCapabilitiesByProductGroups = createSelector(
	getDashboardWidgetCapabilitiesFullSelector,
	(capabilities) => {
		return capabilities.reduce((acc, item, index) => {
			const productGroupName = item.product_group ?? OTHER_GROUP_NAME
			if (!acc[productGroupName]) {
				acc[productGroupName] = {
					id: `${index + 1}`,
					sum: +item?.amount,
					products: {
						[item?.product]: {
							id: +`1${index}`,
							quantity: 1,
							amount: +item?.amount,
						},
					},
				}
			} else {
				acc[productGroupName].sum += +item?.amount
				if (Object.keys(acc[productGroupName].products).includes(item?.product)) {
					acc[productGroupName].products[item?.product].quantity += 1
				} else {
					acc[productGroupName].products[item?.product] = {
						id: +`1${index}`,
						quantity: 1,
						amount: +item?.amount,
					}
				}
			}
			return acc
		}, {} as CapabilitiesByProductGroupsType)
	}
)

const getProductGroupsIds = createSelector(
	getCapabilitiesByProductGroups,
	(capabilitiesByProductGroups) => {
		const values = Object.values(capabilitiesByProductGroups)
		return values.length
			? values.reduce((acc, item) => {
					acc.push(item.id)
					return acc
			  }, [] as string[])
			: []
	}
)

const getDashboardAvailableProducts = (state: AppState) => state.dashboard.availableProducts
export const dashboardSelectors = {
	getDashboardDataSelector,
	getDashboardLoadingSelector,
	getDashboardDateInfoSelector,
	getIsOpenHeaderSelector,
	getDashboardPartnerSelector,
	getShowPartnerSelectSelector,
	getDashboardWidgetCapabilitiesFullSelector,
	getDashboardDataPartner,
	getDashboardAvailableProducts,
	getCapabilitiesByProductGroups,
	getProductGroupsIds,
}
